import { Town, toSlug } from "@models";
import { useStore } from "@stores";
import { useEffect, useMemo } from "react";

interface TownBySlugHook {
  town: Town | undefined;
  loading: boolean;
  /** Spisak gradova je stigao, pa je `town === undefined` konačan odgovor. */
  loaded: boolean;
}

export const useTownBySlug = (slug?: string): TownBySlugHook => {
  const { townStore } = useStore();
  const { towns, loading, loaded } = townStore;

  useEffect(() => {
    if (slug) {
      townStore.getAll();
    }
  }, [townStore, slug]);

  const town = useMemo(
    () => (slug ? towns.find((t) => toSlug(t.nameSr) === slug) : undefined),
    [towns, slug],
  );

  return { town, loading, loaded };
};
